import { useSyncExternalStore } from 'react';
import { canPromptInstall, isInstalledApp, onInstallPromptChange, promptInstall } from '../../pwa';

/** How to put Couch on the home screen; nothing when it already runs as the app (doc 27). */
export function InstallHint() {
  const canPrompt = useSyncExternalStore(onInstallPromptChange, canPromptInstall);
  if (isInstalledApp()) return null;
  return (
    <div className="notice">
      <p><strong>Couch on your phone:</strong> open {window.location.host} there and sign in — no pairing needed, the phone only controls your machines.</p>
      {canPrompt
        ? <button type="button" onClick={() => { void promptInstall(); }}>Install Couch</button>
        : <p className="muted">iPhone/iPad: Safari → Share → “Add to Home Screen”. Android: Chrome menu → “Install app”.</p>}
    </div>
  );
}
